<template>
    <div class="van-page van-main">
        <the-header title="详情" isShowArrow />
        <div class="van-container">
            <div class="van-section">
                <div class="van-section__header">
                    <div class="van-section__title">
                        {{ project.PROJECT_NAME }}
                    </div>
                </div>
                <div class="van-container">
                    <div class="card-item" v-for="(item, index) in listData" :key="index"
                        :class="index % 3 == '0' ? 'bg-blue' : index % 3 == '1' ? 'bg-green' : 'bg-light-blue'">
                        <div class="card-title">{{ item.fileName }}</div>
                        <div class="card-footer">
                            <van-button block @click="handleSee(item)">查看</van-button>
                            <van-button block @click="downloadLisence(item)">下载</van-button>
                        </div>
                    </div>
                    <div class="nomore" v-if="!listData.length">暂无证照列表</div>
                </div>
                <div class="van-section__body">
                    <div class="sub-panel" v-for="(item, index) in listData" :key="index">
                        <div class="sub-header">
                            {{ item.label }}
                        </div>
                        <!-- 缩略图 -->
                        <van-row gutter="16">
                            <van-col span="12" v-for="(cItem, cIndex) in item.images" :key="cIndex">
                                <div class="item-image" @click="handlePreview(cIndex, item)">
                                    <van-image :src="cItem" />
                                </div>
                            </van-col>
                        </van-row>
                        <!-- 预览 -->
                        <van-image-preview v-model="item.show" :startPosition="item.start" :images="item.images"
                            @change="onChange">
                        </van-image-preview>
                    </div>
                </div>
            </div>
        </div>
        <div class="pdfContainer" v-show="pdfActive">
            <div class="cancel" @click="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-circle"
                    viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
            </div>
            <pdfPreview class="pdf" v-if="pdfActive" :url="pdfurl" ref="pdf"></pdfPreview>
        </div>
        <div class="pictureContainer" v-show="pictureActive" @click="pictureActive = !pictureActive">
            <img class="img" :src="pictureurl" alt="">
        </div>
        <van-dialog v-model="fileUrlActive" title="当前设备不支持查看，点击链接复制到浏览器" show-cancel-button :show-confirm-button="false"
            :lazy-render="false">
            <span style="font-size: 14px;color: #555;width: 90%;padding: 16px;text-align: center;margin-left: 5%;"
                @click="clipUrl()" v-clipboard:copy="fileUrl">{{ fileUrl }}</span>
        </van-dialog>
    </div>
</template>
  
<script>
import { getProjectInfo } from '@/api/interface/project'
export default {
    name: 'materialDetail',
    components: {
        'the-header': () => import('@/components/TheHeader'),
        'pdfPreview': () => import('_c/pdfPreview')
    },
    data() {
        return {
            show: false,
            code: null,
            project: null,
            fileUrlActive: false,
            fileUrl: '',
            active: 0,
            listData: [],
            pdfurl: '',
            pdfActive: false,
            pictureurl: '',
            pictureActive: false,
            listData: []
        }
    },
    methods: {
        close: function () {
            this.pdfActive = false
        },
        handlePreview(cIndex, item) {
            item.start = cIndex
            item.show = true
        },
        onChange(index) {
            console.log(index)
        },
        getData() {
            const instance = getProjectInfo({ projectCode: this.code.get('projectCode') })
            instance
                .then((result) => {
                    console.log(result.data.material);
                    this.project = result.data.info
                    this.listData = result.data.material
                }).catch((err) => {
                    console.log(err);
                });
        },
        handleSee(item) {
            const file = item
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
            const textExtensions = ['txt', 'docx', 'doc', 'xlsx', 'pptx', 'xls', 'ppt'];
            const pdfExtensions = ['pdf'];
            var url = `${window.material}?docId=${file.filePath}&fileName=${file.fileName}`
            var that = this

            try {
                if (imageExtensions.some(fileType => file.fileName.includes(fileType))) {
                    this.pictureurl = url
                    this.pictureActive = true
                    return
                }
                if (textExtensions.some(fileType => file.fileName.includes(fileType))) {
                    // 检测当前的设备是否为ios
                    // 判断当前设备
                    if (this.$store.getters.getDevice == 'Android' || this.$store.getters.getDevice == 'web') {
                        this.$dialog.confirm({
                            title: '提示',
                            message: '文件类型不支持预览，是否下载',
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            center: true
                        })
                            .then(() => {
                                const a = document.createElement('a')
                                a.href = url
                                a.download = file.fileName
                                a.click()
                                a.remove()
                            })
                            .catch(() => {
                                console.log('点击了取消')
                            })
                    } else {
                        this.fileUrl = url
                        this.fileUrlActive = true
                    }
                    return
                }
                if (pdfExtensions.some(fileType => file.fileName.includes(fileType))) {
                    this.pdfurl = url
                    this.pdfActive = true
                    return
                }
            } catch (e) {
                var that = this
                // 判断当前设备
                if (this.$store.getters.getDevice == 'Android' || this.$store.getters.getDevice == 'web') {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '文件类型不支持预览，是否下载',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    })
                        .then(() => {
                            const a = document.createElement('a')
                            a.href = url
                            a.download = file.fileName
                            a.click()
                            a.remove()
                        })
                        .catch(() => {
                            console.log('点击了取消')
                        })
                } else {
                    this.fileUrl = url
                    this.fileUrlActive = true
                }
            }
        },
        downloadLisence(item) {
            var url = `${window.material}?docId=${item.filePath}&fileName=${item.fileName}`

            const a = document.createElement('a')
            a.href = url
            a.download = file.fileName
            a.click()
            a.remove()
        },
    },
    created() {
        try {
            const href = location.href
            this.code = new Map()
            if (href.includes('?')) href.split('?')[1].split('&').forEach(item => {
                const temp = item.split('=')
                this.code.set(temp[0], temp[1].split('#')[0])
            });
        } catch (err) {
            console.log(err);
        }
    },
    mounted() {
        this.getData()
    }
}
</script>
  
<style lang="less" scoped>
.van-container {
    padding: 12px 16px;
}


.van-section {
    background: #fff;
    border-radius: 6px;
}

.van-section__header {
    padding: 16px 12px;
}

.van-section__title {
    font-size: 18px;
    font-weight: 600;
}

.van-section__body {
    padding: 0 12px 12px;
}

.sub-panel {
    margin-bottom: 16px;
}

.sub-header {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
}

::v-deep {
    .item-image {
        background: #E0EAFC;
        border-radius: 4px;
        padding: 5px;
        text-align: center;

        .van-image {
            vertical-align: middle;
            height: 96px;
        }
    }

    .van-dialog__header {
        padding: 16px;
    }
}

.lisence-img {
    width: 100%;
    max-height: 50vh;

}

.nomore {
    width: 100%;
    text-align: center;
    margin-top: 20px;
    font-weight: 200;
    color: #888;
}

.card-item {
    height: fit-content;
    border-radius: 8px;
    margin-bottom: 12px;
    background-image: url('../../assets/images/license.png');
    background-position: center;
    background-size: cover;
    color: #fff;
    position: relative;
    display: flex;
    flex-direction: column;

    .card-title {
        font-size: 16px;
        font-weight: 500;
        padding: 14px 14px 0 14px;
        padding-right: 90px;
        height: auto;
        padding: 15px;
        margin-bottom: 15px;
        position: relative;
    }

    .card-title::after {
        content: ' ';
        width: 100%;
        height: calc(100% + 15px);
        bottom: 0;
        left: 0;
        transform: translateY(15px);
        position: absolute;
        background: linear-gradient(to top, rgba(255, 255, 255, 10%) 0%, rgba(255, 255, 255, 0%) 100%);
        // background-color: #427af4;
    }

    .card-footer {
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        background: rgba(255, 255, 255, 1);
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
        position: relative;

        &:before {
            content: '|';
            position: absolute;
            left: 50%;
            top: 50%;
            color: #b4b4b4;
            transform: translateY(-50%);
        }

        .vue-button {
            flex: 1;
        }

        .van-button--default {
            background: transparent;
            border: 0;
            color: #427af4;
        }
    }
}

.bg-blue {
    background:
        linear-gradient(180deg, #6EA1FF 0%, rgba(110, 161, 255, 0) 100%),
        linear-gradient(0deg, #EAEBEE, #EAEBEE);
}

.bg-green {
    background: linear-gradient(180deg, #FFB433 0%, rgba(255, 180, 51, 0) 100%),
        linear-gradient(0deg, #EAEBEE, #EAEBEE);
}

.bg-light-blue {
    background: linear-gradient(180deg, #59C580 0%, rgba(89, 197, 128, 0) 100%),
        linear-gradient(0deg, #EAEBEE, #EAEBEE);
}

.pdfContainer {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .cancel {
        position: absolute;
        right: 20px;
        top: 20px;
        height: 20px;
        color: white;
        z-index: 10000;
    }

    .pdf {
        width: 80vw;

    }
}

.pictureContainer {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.8);

    .img {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 80vw;
        transform: translate(-50%, -50%);

    }
}</style>